import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.css';

class ReasonCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.showInsight = this.showInsight.bind(this);
  }
  showInsight(reason) {
    this.props.requestShowInsight(reason.insight_id);
  }

  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }
  renderReason(reason, isLast = false) {
    const title = `${reason.label}: ${reason.impact_text} ${reason.classification_text}`;
    let textCls = '';
    if (reason.classification_text === 'Disadvantage') {
      textCls = 'text-danger';
    } else if (reason.classification_text === 'Advantage') {
      textCls = 'text-success';
    }

    const popover = (
      <Tooltip id={`reason-${reason.id}`} title={title} className={styles.popover}>
        <div className={`${textCls} text-left`}>
          <div><strong>{title}</strong></div>
          <div>{this.renderHTML(reason.insight_statement)}</div>
        </div>
      </Tooltip>
    );
    const lbl = reason.impact === 1 ? (<strong>{reason.label}</strong>) : (<span>{reason.label}</span>);
    return (
      <OverlayTrigger key={reason.id} trigger="hover" placement="top" overlay={popover}>
        <a 
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.showInsight(reason);
          }}
          className={styles.popoverTrigger}
        >
          {lbl}{!isLast && <span>, </span>}
        </a>
      </OverlayTrigger>
    );
  }

  render() {
    const { value, isClient } = this.props;
    if (value === undefined || value === null || value.length === 0) {
      return null;
    }

    const reasons = filter(value, { is_client : isClient });
    if (reasons.length === 0) {
      return null;
    }

    return <span>{reasons.map((reason, idx) => this.renderReason(reason, idx === reasons.length - 1))}</span>;
  }
}

ReasonCellRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    impact: PropTypes.number,
    impact_text: PropTypes.string,
    classification: PropTypes.number,
    classification_text: PropTypes.string,
    insight_statement: PropTypes.string,
  })),
  requestShowInsight: PropTypes.func,
  isClient: PropTypes.bool.isRequired,
};
ReasonCellRenderer.defaultProps = {
  value: [],
  requestShowInsight: () => {},
};

export default ReasonCellRenderer;
